export default "__VITE_ASSET__CZH4VEJJ__"